import '.a{display:flex;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.au{font-size:0.875rem;}.ssr-plugin'
import '.av{color:var(--gray-300);}.ssr-plugin'
import { Avatar, AvatarSize, AvatarShape } from '@app/components/core/avatar/Avatar'
import { styled } from 'inlines'

interface AuthorProps {
  avatarSrc?: string
  avatarSize?: AvatarSize
  avatarShape?: AvatarShape
  name: string
  description?: string
}

export const Author = ({
  avatarSrc,
  avatarSize = 'small',
  avatarShape = 'circle',
  name,
  description,
}: AuthorProps) => {
  return (
    <div className="a r s"
    >
      <Avatar size={avatarSize} image={avatarSrc} labelSource={name} shape={avatarShape} />

      <div>
        <styled.strong>{name}</styled.strong>
        <div className="au av"
        >
          {description}
        </div>
      </div>
    </div>
  )
}
